import React from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  FormControl,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  Select,
  Tooltip,
} from '@material-ui/core';
import { setSpecificSpecialEventData } from '../../../redux/actions/newOperationHoursActions';
import { formatTime } from '../../../utils/utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    root: {
      flexGrow: 1,
      borderBottom: '1px solid',
      borderBottomColor: '#bdbdbd',
      marginTop: 5,
    },
    demo: {
      backgroundColor: '#f5f5f5',
    },
  }),
);

// eslint-disable-next-line import/no-anonymous-default-export
export default function RowDeparture({ disableAll, restaurantId = '' }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch: any = useDispatch();

  const { specialEventDeparture, specialEventTimes, closeToAll, is12HFormat } =
    useSelector((state: RootStateOrAny) => state.NewOperationHoursReducer);

  const disabledSelects = disableAll;
  const onChangeSelectOpen = event => {
    const select = event.target as HTMLSelectElement;
    if (specialEventDeparture !== select.value) {
      dispatch(
        setSpecificSpecialEventData({
          specialEventDeparture: select.value,
        }),
      );
    }
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={4} md={4}>
          <div className={classes.demo}>
            <List>
              <ListItem>
                <ListItemText
                  primary={t('operationHours.storeDeparture')}
                  primaryTypographyProps={{ display: 'inline' }}
                  secondary={!restaurantId && !closeToAll ? '*' : ''}
                  secondaryTypographyProps={
                    !restaurantId
                      ? { display: 'inline', color: 'error', variant: 'h5' }
                      : undefined
                  }
                />
              </ListItem>
            </List>
          </div>
        </Grid>
        <Grid item xs={2} md={2}></Grid>
        <Grid item xs={3} md={3}>
          <Tooltip title={''}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel htmlFor="outlined-time-native-simple">
                {t('operationHours.specialEventDeparture')}
              </InputLabel>
              <Select
                style={
                  disabledSelects
                    ? { pointerEvents: 'none', color: 'grey' }
                    : undefined
                }
                native
                value={specialEventDeparture ? specialEventDeparture : ''}
                label={t('operationHours.start')}
                inputProps={{
                  name: 'specialEventTimes',
                  id: 'outlined-time-native-simple',
                }}
                onChange={onChangeSelectOpen}
                disabled={disabledSelects}
              >
                {specialEventTimes?.map((elem, index) => (
                  <option key={index} value={elem}>
                    {formatTime(elem, is12HFormat)}
                  </option>
                ))}
                <option key={'23:59'} value={'23:59'} hidden={true}>
                  {formatTime('23:59', is12HFormat)}
                </option>
              </Select>
            </FormControl>
          </Tooltip>
        </Grid>
      </Grid>
    </div>
  );
}

RowDeparture.displayName = 'RowDeparture';
